import React from 'react'
import LandingPage from '../layout/UserManagement/UserManagement.tsx'
const UserManagement = () => {
  return (
    <div>
       <LandingPage/>
    </div>
  )
}

export default UserManagement
